import React, { useEffect, useMemo, useState, useCallback } from "react";
import { Container, Card, Table, Button, Badge, Spinner, Modal, Form } from "react-bootstrap";
import Swal from "sweetalert2";

import {API_BASE} from "../../services/apirest";
import InformacionUsuario from "../modales/InformacionUsuario";
import AvatarCentrado from "../modales/AvatarCentrado";
import FotoINE from "../modales/FotoINE";


export default function EjecutarModificaciones() {
  const rolId = Number(localStorage.getItem("rol_id"));
  const [list, setList] = useState(null);
  const [selected, setSelected] = useState(null);
  const [showDetailModal, setShowDetailModal] = useState(false);


  // --------- Credenciales ---------
  const [showCredModal, setShowCredModal] = useState(false);
 const [credForm, setCredForm] = useState({
  usuario_red: "",
  ccven: "",
});
const [credChecks, setCredChecks] = useState({
  check_toa: 0,
  check_pi_siebel: 0,
});
  const [loadingExec, setLoadingExec] = useState(false);

  // --------- Búsquedas ---------
  const [searchRFC, setSearchRFC] = useState("");
  const [searchVendedor, setSearchVendedor] = useState("");

  // --------- NUEVO: FGU (modales + valores) ---------
  const [showFGUUserModal, setShowFGUUserModal] = useState(false); // fgu_usuario
  const [showFGUToaModal, setShowFGUToaModal]   = useState(false); // fgu_toa (solo si new_rol_id = 9)
  const [fguUserValue, setFguUserValue] = useState("");
  const [fguToaValue,  setFguToaValue]  = useState("");
  const requiresPi = (row) => Number(parseMod(row)?.new_rol_id) === 9;
  const [showFGUPiModal, setShowFGUPiModal] = useState(false);
  const [fguPiValue, setFguPiValue] = useState("");
  const isStOn = (row) => Number(row?.st) === 1; // "0" -> 0, "1" -> 1
  const requiresSt = (row) => Number(parseMod(row)?.new_rol_id) === 9;

  // --------------------------------

  const headers = useMemo(
    () => ({
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    }),
    []
  );

  // Nombres de roles
  const roleLabels = useMemo(
    () => ({
      8: "VENDEDOR (ACTIVE DIRECTORI/SIBEL TELCOM)",
      9: "VENDEDOR / INSTALADOR (TOA)",
      10: "SUPERVISOR",
      11: "ADMINISTRATIVO",
    }),
    []
  );
  const rolName = (id) => roleLabels?.[Number(id)] ?? `ROL ${id}`;
  // Guarda un check en BD y sincroniza UI
// reemplaza tu persistCheck por este
const persistCheck = async (field, checked) => {
  if (!selected) return;
  const next = checked ? 1 : 0;
  try {
    const res = await fetch(`${API_BASE}/solicitudes.php`, {
      method: "PUT",
      headers,
      body: JSON.stringify({
        SolicitudId: selected.SolicitudId,
        [field]: next,            // ⬅️ SOLO el check que cambió
      }),
    });
    const j = await res.json();
    if (j.status === "success" || j.status === "ok") {
      setCredChecks((p) => ({ ...p, [field]: next }));
      setSelected((p) => (p ? { ...p, [field]: next } : p));
      setList((prev) =>
        (prev || []).map((it) =>
          it.SolicitudId === selected.SolicitudId ? { ...it, [field]: next } : it
        )
      );
    } else {
      Swal.fire("Error", j.result?.error_msg || j.message || "No se pudo guardar", "error");
    }
  } catch {
    Swal.fire("Error", "No se pudo conectar al servidor", "error");
  }
};


  // Helpers para modificación
  const parseMod = (row) => {
    try {
      return JSON.parse(row?.modificaciones_data || "{}");
    } catch {
      return {};
    }
  };
  const requiresToa = (row) => Number(parseMod(row)?.new_rol_id) === 9;
  const fguReady = (row) => {
    const needToa = requiresToa(row);
    const needPi  = requiresPi(row);
    const okBase  = !!row.fgu_usuario; // <- sin fgu_usuario_red
    const withToa = needToa ? okBase && !!row.fgu_toa : okBase;
    const withPi  = needPi  ? withToa && !!row.fgu_pi  : withToa;
    return withPi;
  };

const stPersisted = selected ? Number(selected.st) === 1 : false;
const needRole9   = selected ? Number(parseMod(selected)?.new_rol_id) === 9 : false;

const canExecute =
  !needRole9 ||
  (Number(selected?.check_toa) === 1 &&
   Number(selected?.check_pi_siebel) === 1 &&
   stPersisted);



const readyAndSt = (row) => {
  const fgusOk = fguReady(row);
  const stOk   = requiresSt(row) ? isStOn(row) : true; // ST solo para rol nuevo 9
  return fgusOk && stOk;
};

const topSwal = (opts) =>
  Swal.fire({
    heightAuto: false,
    ...opts,
    didOpen: () => {
      const c = Swal.getContainer();
      if (c) c.style.zIndex = "20000"; // encima del modal de Bootstrap (~11000)
    },
  });



  // Cargar lista para ejecutar
  const load = useCallback(async () => {
    try {
      const res = await fetch(`${API_BASE}/solicitudes.php?modificacion=por_ejecutar`, { headers });

      const j = await res.json();
      const datos = j?.status === "success" ? (j.result?.solicitudes || j.result || []) : [];
      setList(Array.isArray(datos) ? datos : []);
    } catch {
      setList([]);
    }
  }, [headers]);

  useEffect(() => {
    if (rolId !== 1 && rolId !== 14) {
      setList([]); // por si alguien entra sin permiso
      return;
    }
    load();
    const poll = setInterval(load, 30000);
    return () => clearInterval(poll);
  }, [load, rolId]);

  const filtered = useMemo(() => {
    if (!Array.isArray(list)) return [];
    return list
      .filter((s) =>
        searchRFC ? String(s.rfc || "").toUpperCase().includes(searchRFC.toUpperCase()) : true
      )
      .filter((s) =>
        searchVendedor ? String(s.numero_vendedor || "").includes(searchVendedor) : true
      )
      .sort((a, b) => new Date(b.Fecha) - new Date(a.Fecha));
  }, [list, searchRFC, searchVendedor]);

  

  // Abrir modal de credenciales (solo si FGU listo)
const openCredModal = (row) => {
  if (!fguReady(row)) {
    return Swal.fire("Completa FGU", "Debes registrar los FGU requeridos antes de generar credenciales.", "warning");
  }
  if (requiresSt(row) && !isStOn(row)) {
    return Swal.fire("Marca ST", "Debes palomear ST antes de continuar.", "warning");
  }

  setSelected(row);
  setCredForm({
    usuario_red: row.usuario_red || "",
    cvven: row.cvven || row.ccven || "",
  });
  setCredChecks({
    check_toa: Number(row.check_toa) ? 1 : 0,
    check_pi_siebel: Number(row.check_pi_siebel) ? 1 : 0,
  });
  setShowCredModal(true);
};



  // Ejecutar cambio (PUT ejecutar_modificacion)
 const ejecutarCambio = async () => {
  if (!selected) return;

  if (!fguReady(selected)) {
    return Swal.fire("Completa FGU", "Aún faltan FGU requeridos para este rol.", "warning");
  }
if (needRole9 && !canExecute) {
  return Swal.fire({
    title: "Faltan confirmaciones",
    text: "Marca TOA y PI Siebel (ST ya debe estar) para continuar.",
    icon: "warning",
    heightAuto: false,
    didOpen: () => {
      const c = Swal.getContainer();
      if (c) c.style.zIndex = "20000";
    },
  });
}

  Swal.close();
  const confirm = await topSwal({
  icon: "question",
  title: "¿Ejecutar cambio de credenciales?",
  html: `
    <div style="text-align:left">
      <p><b>RFC:</b> ${selected?.rfc ?? ""}</p>
      <p><b>Usuario SIEBEL:</b> ${selected?.numero_vendedor ?? ""}</p>
      <hr style="margin:8px 0"/>
      <p><b>Usuario red:</b> ${credForm.usuario_red || "-"}</p>
      <hr style="margin:8px 0"/>
      <p><b>Checks</b></p>
      <ul style="margin-left:1rem">
        <li>ST: ${stPersisted ? "✅" : "❌"}</li>
        ${needRole9 ? `
          <li>TOA: ${Number(selected?.check_toa) === 1 ? "✅" : "❌"}</li>
          <li>PI Siebel: ${Number(selected?.check_pi_siebel) === 1 ? "✅" : "❌"}</li>
        ` : ""}
      </ul>
    </div>
  `,
  showCancelButton: true,
  confirmButtonText: "Sí, ejecutar",
  cancelButtonText: "Cancelar",
  reverseButtons: true,
});

  if (!confirm.isConfirmed) return;

  const payload = { action: "ejecutar_modificacion", SolicitudId: selected.SolicitudId };
  Object.entries(credForm).forEach(([k, v]) => {
    const val = String(v ?? "").trim();
    if (val) payload[k] = val;
  });

  // ← persistimos checks si aplica
  if (needRole9) {
    payload.check_toa = credChecks.check_toa ? 1 : 0;
    payload.check_pi_siebel = credChecks.check_pi_siebel ? 1 : 0;
  }

  if (Object.keys(payload).length === 2) {
    return Swal.fire("Aviso", "Completa al menos un campo de credenciales.", "warning");
  }

  try {
    setLoadingExec(true);
    const res = await fetch(`${API_BASE}/solicitudes.php`, {
      method: "PUT",
      headers,
      body: JSON.stringify(payload),
    });
    const j = await res.json();
    setLoadingExec(false);
   setLoadingExec(false);

if (j.status === "success" || j.status === "ok") {
  await topSwal({
    icon: "success",
    title: "Modificación ejecutada",
    html: `
      <div style="text-align:left">
        <p><b>Solicitud:</b> ${selected?.SolicitudId ?? ""}</p>
        <p><b>Nuevo rol aplicado.</b></p>
        ${j.message ? `<p>${j.message}</p>` : ""}
      </div>
    `,
    confirmButtonText: "Aceptar",
  });

  // cerrar modal y sacar la fila
  window.dispatchEvent(new Event("solicitudes:refresh"));
  window.dispatchEvent(new Event("inbox:refresh"));
  setShowCredModal(false);
  const idOut = selected.SolicitudId;
  setSelected(null);
  setList((prev) => (prev || []).filter((s) => s.SolicitudId !== idOut));
} else {
  topSwal({
    icon: "error",
    title: "Error",
    text: j.result?.error_msg || j.message || "No se pudo ejecutar",
  });
}

  } catch {
    setLoadingExec(false);
    Swal.fire("Error", "No se pudo conectar al servidor", "error");
  }
};


  if (rolId !== 1 && rolId !== 14) {
    return (
      <Container className="py-5">
        <Card body className="text-center text-muted">
          Solo usuarios con rol <strong>1</strong> pueden ejecutar modificaciones.
        </Card>
      </Container>
    );
  }

  if (list === null) {
    return (
      <Container className="d-flex justify-content-center align-items-center" style={{ height: "60vh" }}>
        <Spinner animation="border" />
      </Container>
    );
  }

  return (
    <div className="app-container">
      <Container className="my-5">
        <div className="d-flex gap-3 align-items-end mb-3">
          <Form.Group>
            <Form.Label>Buscar por RFC</Form.Label>
            <Form.Control
              placeholder="RFC…"
              value={searchRFC}
              onChange={(e) => setSearchRFC(e.target.value)}
              style={{ minWidth: 220 }}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Buscar No. Vendedor</Form.Label>
            <Form.Control
              placeholder="Número…"
              value={searchVendedor}
              onChange={(e) => setSearchVendedor(e.target.value)}
              style={{ minWidth: 220 }}
            />
          </Form.Group>
          <div className="ms-auto">
            <Button variant="outline-secondary" onClick={load}>
              Actualizar
            </Button>
          </div>
        </div>

        <Card className="shadow-sm">
          <Card.Header className="d-flex justify-content-between align-items-center">
            <h5 className="mb-0">Modificaciones por ejecutar</h5>
            <Badge bg={filtered.length > 0 ? "info" : "secondary"} pill>
              {filtered.length}
            </Badge>
          </Card.Header>
          <Card.Body>
            {filtered.length === 0 ? (
              <p className="text-center text-muted mb-0">
                No hay solicitudes pendientes.
              </p>
            ) : (
              <Table responsive hover striped className="mb-0 align-middle">

                <thead>
                  <tr>
                     <th>#</th>
                    <th>Nombre</th>
                    <th>RFC</th>
                    <th>No. Vendedor</th>
                    <th>Usuario de red</th>
                    <th>Rol actual → nuevo</th>
                    <th>Fecha</th>
                    <th className="text-center">Acción</th>

                  </tr>
                </thead>
                <tbody>
                  {filtered.map((s) => {
                    let mod = parseMod(s);
                    const needToa = requiresToa(s);
                    return (
                      <tr key={s.SolicitudId}>
                         <td>{s.SolicitudId}</td>
                        <td
                          style={{ cursor: "pointer", color: "#0056b3", textDecoration: "underline" }}
                          onClick={() => {
                            setSelected(s);
                            setShowDetailModal(true);
                          }}
                        >
                          {[
                            s.nombre_usuario,
                            s.apellido_paterno,
                            s.apellido_materno,
                          ]
                            .filter(Boolean)
                            .join(" ")}
                        </td>
                        <td>{s.rfc}</td>
                        <td>{s.numero_vendedor}</td>
                        <td>{s.usuario_red}</td>

                        <td>
                          {rolName(s.rol_id)} →{" "}
                          <strong>{rolName(mod.new_rol_id)}</strong>
                        </td>
                        <td>{new Date(s.Fecha).toLocaleDateString()}</td>
                        <td className="text-center text-nowrap">
                          <div className="d-flex align-items-center flex-nowrap gap-2 justify-content-center w-100">
                            {/* FGU SIEBEL TELCO */}
                            {!s.fgu_usuario && (
                              <Button
                                size="sm"
                                variant="info"
                                onClick={() => {
                                  setSelected(s);
                                  setFguUserValue(s.fgu_usuario || "");
                                  setShowFGUUserModal(true);
                                }}
                              >
                                FGU SIEBEL TELCO
                              </Button>
                            )}
                            {/* FGU TOA */}
                            {needToa && !s.fgu_toa && (
                                <Button
                                    size="sm"
                                    variant="secondary"
                                    onClick={() => {
                                      setSelected(s);
                                      setFguToaValue(s.fgu_toa || "");
                                      setShowFGUToaModal(true);
                                    }}
                                >
                                  FGU TOA
                                </Button>
                            )}
                            {/* FGU PI */}
                            {requiresPi(s) && !s.fgu_pi && (
                              <Button
                                size="sm"
                                variant="secondary"
                                onClick={() => {
                                  setSelected(s);
                                  setFguPiValue(s.fgu_pi || "");
                                  setShowFGUPiModal(true);
                                }}
                              >
                                FGU PI
                              </Button>
                            )}

                               {requiresSt(s) &&
                              !isStOn(s) && ( // solo mostrar si aún NO está marcado
                                <Form.Check
                                  inline
                                  type="checkbox"
                                  id={`chk-st-${s.SolicitudId}`}
                                  label="ST"
                                  className="me-2"
                                  checked={isStOn(s)} // será false cuando st venga "0"
                                  onChange={async () => {
                                    const next = 1; // al palomear, lo dejamos fijo en 1
                                    const res = await fetch(
                                      `${API_BASE}/solicitudes.php`,
                                      {
                                        method: "PUT",
                                        headers,
                                        body: JSON.stringify({
                                          SolicitudId: s.SolicitudId,
                                          st: next,
                                        }),
                                      }
                                    );
                                    const j = await res.json();
                                    if (
                                      j.status === "success" ||
                                      j.status === "ok"
                                    ) {
                                      // actualizar la fila en memoria para que desaparezca el check
                                      setList((prev) =>
                                        (prev || []).map((it) =>
                                          it.SolicitudId === s.SolicitudId
                                            ? { ...it, st: next }
                                            : it
                                        )
                                      );
                                    } else {
                                      Swal.fire(
                                        "Error",
                                        j.result?.error_msg ||
                                          j.message ||
                                          "No se pudo guardar ST",
                                        "error"
                                      );
                                    }
                                  }}
                                />
                              )}

                            <Button
                              size="sm"
                              variant="warning"
                              className={readyAndSt(s) ? "" : "invisible"} // mantiene el ancho si aún no aplica
                              disabled={!readyAndSt(s)}
                              onClick={() => openCredModal(s)}
                            >
                              Generar/Cambiar cred.
                            </Button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            )}
          </Card.Body>
        </Card>

        {/* Modal credenciales */}
        <Modal
          show={showCredModal}
          onHide={() => setShowCredModal(false)}
          centered
          backdrop="static"
          style={{ zIndex: 11000 }}
        >
          <Modal.Header closeButton>
            <Modal.Title>Actualizar credenciales</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>USUARIO RED</Form.Label>
                <Form.Control
                  type="text"
                  value={credForm.usuario_red}
                  onChange={(e) =>
                    setCredForm((p) => ({
                      ...p,
                      usuario_red: e.target.value,
                    }))
                  }
                />
              </Form.Group>
              <Form.Group className="mb-0">
                <Form.Label>CVVEN</Form.Label>
                <Form.Control
                  type="text"
                  value={credForm.cvven}
                  onChange={(e) => setCredForm((p) => ({ ...p, cvven: e.target.value }))}
                />
              </Form.Group>
            </Form>

            {selected && requiresToa(selected) && (
              <fieldset className="mt-3">
                <div className="d-flex flex-column gap-2">
                  <Form.Check
                    id="chk-toa"
                    type="checkbox"
                    label="TOA"
                    checked={Number(selected?.check_toa) === 1}
                    onChange={(e) => persistCheck("check_toa", e.target.checked)}
                  />
                  <Form.Check
                    id="chk-pi"
                    type="checkbox"
                    label="PI Siebel"
                    checked={Number(selected?.check_pi_siebel) === 1}
                    onChange={(e) => persistCheck("check_pi_siebel", e.target.checked)}
                  />
                  <Form.Check
                    id="chk-st"
                    type="checkbox"
                    label="Suministro Técnico (ST)"
                    checked={stPersisted}
                    disabled // ST solo informativo (ya se marcó antes en la tabla)
                  />
                </div>
              </fieldset>
            )}

          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowCredModal(false)}>
              Cancelar
            </Button>
           <Button
            variant="primary"
            disabled={loadingExec || !canExecute}
            onClick={ejecutarCambio}
          >
            {loadingExec ? "Procesando..." : "Ejecutar"}
          </Button>
          </Modal.Footer>
        </Modal>

        {/* --------- Modales FGU --------- */}
        <Modal
          show={showFGUPiModal}
          onHide={() => setShowFGUPiModal(false)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>INGRESAR FGU PI</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group>
              <Form.Label>FGU PI</Form.Label>
              <Form.Control
                type="text"
                value={fguPiValue}
                onChange={(e) => setFguPiValue(e.target.value)}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowFGUPiModal(false)}
            >
              Cancelar
            </Button>
            <Button
              variant="primary"
              onClick={async () => {
                const val = fguPiValue.trim();
                if (!val)
                  return Swal.fire(
                    "Error",
                    "Debes ingresar un valor",
                    "warning"
                  );
                const res = await fetch(`${API_BASE}/solicitudes.php`, {
                  method: "PUT",
                  headers,
                  body: JSON.stringify({
                    SolicitudId: selected.SolicitudId,
                    fgu_pi: val,
                  }),
                });
                const j = await res.json();
                if (j.status === "success" || j.status === "ok") {
                  Swal.fire("¡LISTO!", "FGU PI registrado", "success");
                  window.dispatchEvent(new Event("solicitudes:refresh"));
                  window.dispatchEvent(new Event("inbox:refresh"));
                  setShowFGUPiModal(false);
                  setSelected(null);
                  setFguPiValue("");
                  load();
                } else {
                  Swal.fire(
                    "Error",
                    j.result?.error_msg || "No se pudo guardar",
                    "error"
                  );
                }
              }}
            >
              Guardar
            </Button>
          </Modal.Footer>
        </Modal>

        {/* FGU SIEBEL TELCO (fgu_usuario) */}
        <Modal
          show={showFGUUserModal}
          onHide={() => setShowFGUUserModal(false)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>INGRESAR FGU SIEBEL TELCO</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group>
              <Form.Label>FGU SIEBEL TELCO</Form.Label>
              <Form.Control
                type="text"
                value={fguUserValue}
                onChange={(e) => setFguUserValue(e.target.value)}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowFGUUserModal(false)}
            >
              Cancelar
            </Button>
            <Button
              variant="primary"
              onClick={async () => {
                if (!fguUserValue.trim())
                  return Swal.fire(
                    "Error",
                    "Debes ingresar un valor",
                    "warning"
                  );
                const res = await fetch(`${API_BASE}/solicitudes.php`, {
                  method: "PUT",
                  headers,
                  body: JSON.stringify({
                    SolicitudId: selected.SolicitudId,
                    fgu_usuario: fguUserValue.trim(),
                  }),
                });
                const j = await res.json();
                if (j.status === "success" || j.status === "ok") {
                  Swal.fire(
                    "¡LISTO!",
                    "FGU SIEBEL TELCO registrado",
                    "success"
                  );
                  window.dispatchEvent(new Event("solicitudes:refresh"));
                  window.dispatchEvent(new Event("inbox:refresh"));
                  setShowFGUUserModal(false);
                  setSelected(null);
                  setFguUserValue("");
                  load();
                } else {
                  Swal.fire(
                    "Error",
                    j.result?.error_msg || "No se pudo guardar",
                    "error"
                  );
                }
              }}
            >
              Guardar
            </Button>
          </Modal.Footer>
        </Modal>

        {/* FGU TOA (fgu_toa) — solo si new_rol_id = 9 */}
        <Modal
          show={showFGUToaModal}
          onHide={() => setShowFGUToaModal(false)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>INGRESAR FGU TOA</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group>
              <Form.Label>FGU TOA</Form.Label>
              <Form.Control
                type="text"
                value={fguToaValue}
                onChange={(e) => setFguToaValue(e.target.value)}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowFGUToaModal(false)}
            >
              Cancelar
            </Button>
            <Button
              variant="primary"
              onClick={async () => {
                if (!fguToaValue.trim())
                  return Swal.fire(
                    "Error",
                    "Debes ingresar un valor",
                    "warning"
                  );
                const res = await fetch(`${API_BASE}/solicitudes.php`, {
                  method: "PUT",
                  headers,
                  body: JSON.stringify({
                    SolicitudId: selected.SolicitudId,
                    fgu_toa: fguToaValue.trim(),
                  }),
                });
                const j = await res.json();
                if (j.status === "success" || j.status === "ok") {
                  Swal.fire("¡LISTO!", "FGU TOA registrado", "success");
                  window.dispatchEvent(new Event("solicitudes:refresh"));
                  window.dispatchEvent(new Event("inbox:refresh"));
                  setShowFGUToaModal(false);
                  setSelected(null);
                  setFguToaValue("");
                  load();
                } else {
                  Swal.fire(
                    "Error",
                    j.result?.error_msg || "No se pudo guardar",
                    "error"
                  );
                }
              }}
            >
              Guardar
            </Button>
          </Modal.Footer>
        </Modal>
         {/* --------- /Modales FGU --------- */}

        {/* Modal Detalle */}
        <Modal
          show={showDetailModal}
          onHide={() => setShowDetailModal(false)}
          size="lg"
          centered
          dialogClassName="modal-100w"
          style={{ zIndex: 11000 }}
        >
          <Modal.Header closeButton>
            <Modal.Title>Detalle Solicitud</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selected && (
              <>
                {/* Avatar centrado */}
                <AvatarCentrado src={selected?.foto_url} alt="Foto del vendedor" />

                {/* 1) Distribuidor */}
                <InformacionUsuario
                  user={selected}
                  title="Distribuidor"
                  cols={2}
                  fields={[
                    { key: "distribuidor_nombre", label: "Distribuidor" },
                    { key: "distribuidor_rs", label: "Razón Social" },
                  ]}
                />

                {/* 3) Datos del usuario */}
                <InformacionUsuario
                  user={selected}
                  title="Datos del usuario"
                  cols={3}
                  fields={[
                    { key: "usuario", label: "Email", render: (u) => u?.usuario || u?.Usuario || "—" },
                    {
                      key: "nombre_completo",
                      label: "Nombre completo",
                      render: (u) =>
                        [u?.nombre_usuario, u?.apellido_paterno, u?.apellido_materno]
                          .filter(Boolean)
                          .join(" "),
                    },
                    { key: "telefono", label: "Teléfono" },
                    { key: "Fecha", label: "Fecha Ingreso", render: (u) => u?.Fecha ? new Date(u.Fecha).toLocaleDateString("es-MX") : "—" },
                    { key: "rfc", label: "RFC", render: (u) => (u?.rfc || "—").toUpperCase() },
                    { key: "numero_vendedor", label: "Número Empleado" },
                  ]}
                />

                {/* 4) Puesto y credenciales */}
                <InformacionUsuario
                  user={selected}
                  title="Puesto y credenciales"
                  cols={3}
                  hideEmpty={false}
                  fields={[
                    { key: "rol_id", label: "Puesto Actual", render: (u) => rolName(u?.rol_id) },
                    { key: "supervisor", label: "Supervisor Interno IZZI" },
                    { key: "usuario_red", label: "Usuario red", render: (u) => (u?.usuario_red || "—").toUpperCase() },
                    { key: "cvven", label: "CVVEN", render: (u) => u?.cvven || u?.ccven || "—" },
                  ]}
                />

                {/* 5) Modificación de Rol */}
                {parseMod(selected)?.new_rol_id && (
                  <InformacionUsuario
                    user={selected}
                    title="Modificación de Rol"
                    cols={1}
                    fields={[
                      {
                        key: "rol_change",
                        label: "Cambio de Puesto",
                        render: (u) => (
                          <div className="d-flex align-items-center">
                            <Badge bg="secondary" className="px-2 py-1" style={{ fontSize: "0.9rem" }}>
                              {rolName(u?.rol_id)}
                            </Badge>
                            <span className="mx-2" style={{ fontSize: "1.2rem", color: "#6c757d", fontWeight: "bold" }}>→</span>
                            <Badge bg="primary" className="px-2 py-1" style={{ fontSize: "0.9rem" }}>
                              {rolName(parseMod(u)?.new_rol_id)}
                            </Badge>
                          </div>
                        ),
                      },
                    ]}
                  />
                )}

                {/* 6) Ubicación */}
                <InformacionUsuario
                  user={selected}
                  title="Ubicación"
                  cols={3}
                  fields={[
                    { key: "region_hub", label: "HUB" },
                    { key: "region_nombre", label: "Región" },
                    { key: "region_plaza", label: "Plaza" },
                  ]}
                />
                
                {/* Foto INE */}
                <hr />
                <FotoINE url={selected?.ine_url} />
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowDetailModal(false)}
            >
              Cerrar
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </div>
  );
}

